import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { authService } from '../services/auth';

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [userConfig, setUserConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const reloadUserConfig = useCallback(() => {
    return new Promise((resolve, reject) => {
      authService.fetchUser(
        (res) => {
          setUserConfig(res.data);
          setLoading(false);
          resolve(res.data);
        },
        (err) => {
          setLoading(false);
          reject(err);
        },
      );
    });
  }, []);

  useEffect(() => {
    reloadUserConfig().catch(console.error);
  }, [reloadUserConfig]);

  const value = useMemo(
    () => ({ userConfig, loading, reloadUserConfig }),
    [userConfig, loading, reloadUserConfig],
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUser() {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error('useUser must be used within UserProvider');
  return ctx;
}
